"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpacer = void 0;
var _Spacer = require("./Spacer");
// TODO: in v9, move styled() from Spacer.jsx to here
var StyledSpacer = _Spacer.Spacer;
exports.StyledSpacer = StyledSpacer;